import { Component, computed, HostListener, input, model } from '@angular/core';

@Component({
	selector: 'summary-navigation',
	templateUrl: './summary-navigation.component.html',
	imports: [],
})
export class SummaryNavigationComponent {
	numberOfSlides = input<number>(0);

	currentSlideIndex = model<number>(0);

	indexRange = computed(() => {
		return Array.from({ length: this.numberOfSlides() }, (_, i) => i);
	});

	onClick(index: number): void {
		this.currentSlideIndex.set(index);
	}

	@HostListener('window:keydown', ['$event'])
	protected onKeydown(e: KeyboardEvent): void {
		const total = this.numberOfSlides();
		const current = this.currentSlideIndex();

		if (e.key === 'ArrowLeft') {
			const prev = Math.max(0, current - 1);
			if (prev !== current) this.currentSlideIndex.set(prev);
		} else if (e.key === 'ArrowRight') {
			const next = Math.min(Math.max(0, total - 1), current + 1);
			if (next !== current) this.currentSlideIndex.set(next);
		}
	}
}
